import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import Icon from '../Icons/Icon';

const DragHandle = SortableHandle(() => (
  <Icon name="drag-handle" size="m" fill="grey" classes="drag-handle" />
));

export default DragHandle;



// WEBPACK FOOTER //
// ./library/app/components/Global/Sortable/DragHandle.js